import { Routes } from '@angular/router';
import { guestOnlyGuard } from './features/auth/guards/guest-only.guard';
import { authGuard } from './features/auth/guards/auth.guard';
import { isTenantGuard } from './features/auth/guards/is-tenant.guard';
import { isLandlordGuard } from './features/auth/guards/is-landlord.guard';
import { landlordOnlyGuard } from './features/auth/guards/landlord-only.guard';
import { tenantOnlyGuard } from './features/auth/guards/tenant-only.guard';
import { projectSelectedGuard } from './features/auth/guards/project-selected.guard';

export const routes: Routes = [
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./features/auth-callback/auth-callback.component')
        .then((m) => m.AuthCallbackComponent),
  },
  {
    path: 'faqs',
    loadComponent: () =>
      import('./features/faqs/faqs.component')
        .then((m) => m.FaqsComponent),
  },
  {
    path: '',
    canActivate: [authGuard, projectSelectedGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard.component')
        .then((m) => m.DashboardComponent),
    children: [
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.route')
            .then((m) => m.SettingsRouteModule),
      },
      {
        path: 'deals/:id',
        canActivate: [landlordOnlyGuard],
        loadComponent: () =>
          import('./features/deal-details/deal-details.component')
            .then((m) => m.DealDetailsComponent),
      },
      {
        path: 'location/:id',
        canActivate: [tenantOnlyGuard],
        loadComponent: () =>
          import('./features/location-details/location-details.component')
            .then((m) => m.LocationDetailsComponent),
      },
      {
        path: 'map-editor',
        canActivate: [landlordOnlyGuard],
        canDeactivate: [
          () => import('./features/map-editor/guards/map-editor-unsaved-changes.guard')
            .then((m) => m.mapEditorUnsavedChangesGuard),
        ],
        loadComponent: () =>
          import('./features/map-editor/map-editor.component')
            .then((m) => m.MapEditorComponent),
      },
      {
        path: '',
        canMatch: [isTenantGuard],
        canActivate: [tenantOnlyGuard],
        loadComponent: () =>
          import('./features/location-list/location-list.component')
            .then((m) => m.LocationListComponent),
      },
      {
        path: '',
        canMatch: [isLandlordGuard],
        canActivate: [landlordOnlyGuard],
        loadComponent: () =>
          import('./features/property-list/property-list.component')
            .then((m) => m.PropertyListComponent),
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./features/user-account-onboarding/user-account-onboarding.component')
      .then((m) => m.UserAccountOnboardingComponent),
    canActivate: [guestOnlyGuard],
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/login/login.component')
            .then((m) => m.LoginComponent),
      },
      // This particular route may contain multiple slashes,
      // treat it as if its still part of the token
      {
        path: 'invites/:token',
        children: [
          {
            path: '**',
            loadComponent: () =>
              import('./features/invites/invites.component')
                .then((m) => m.InvitesComponent),
          },
        ],
      },
    ],
  },
  {
    path: 'portal',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/portal/portal.component')
        .then((m) => m.AccountComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/404/404.component')
        .then((m) => m.NotFoundComponent),
  },
];
